import {
  Box,
  Center,
  Flex,
  IconButton,
  Image,
  Modal,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import * as React from 'react';

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  XIcon,
} from '@/imports/ui/chakra/feather';
import { VideoJsPlayer } from '@/imports/ui/components/Video/VideoJsPlayer/VideoJsPlayer';

type IResourceCarouselProps = {
  slides: { id: string; imageProxy?: string; videoUrl?: string }[];
  currentSlide: number;
  isOpen: boolean;
  onClose: () => void;
};

export const ResourceCarousel: React.FC<IResourceCarouselProps> = (props) => {
  const [currentSlide, setCurrentSlide] = React.useState(props.currentSlide);

  React.useEffect(() => {
    setCurrentSlide(props.currentSlide);
  }, [props.currentSlide]);

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="full" isCentered>
      <ModalOverlay bg="blackAlpha.900" />
      <ModalContent
        m="0"
        bg="transparent"
        onKeyDown={(e) => {
          if (e.keyCode === 37) {
            setCurrentSlide((s) => (s === 0 ? props.slides.length - 1 : s - 1));
          } else if (e.keyCode === 39) {
            setCurrentSlide((s) => (s === props.slides.length - 1 ? 0 : s + 1));
          }
        }}
      >
        <IconButton
          variant="outline"
          borderRadius="full"
          colorScheme="gray"
          pos="absolute"
          top={4}
          right={4}
          icon={<XIcon />}
          aria-label="Close"
          onClick={props.onClose}
        />

        <Center w="full">
          <Flex w="full" overflow="hidden">
            <Flex
              h="100vh"
              w="full"
              transition="all .5s"
              ml={`-${currentSlide * 100}%`}
            >
              {props.slides.map(({ id, imageProxy, videoUrl }) => (
                <Center key={id} boxSize="full" flex="none">
                  {videoUrl ? (
                    <Box w="80vh">
                      <VideoJsPlayer
                        src={videoUrl}
                        type="application/x-mpegURL"
                      />
                    </Box>
                  ) : (
                    <Image
                      src={imageProxy}
                      objectFit="contain"
                      maxH="full"
                      alt="image resource"
                      fallback={<></>}
                      loading="lazy"
                    />
                  )}
                </Center>
              ))}
            </Flex>

            {props.slides.length > 1 && (
              <>
                <IconButton
                  variant="outline"
                  borderRadius="full"
                  colorScheme="gray"
                  pos="absolute"
                  top="50%"
                  left={4}
                  transform="translateY(-50%)"
                  icon={<ChevronLeftIcon />}
                  aria-label="Previous"
                  onClick={() =>
                    setCurrentSlide((s) =>
                      s === 0 ? props.slides.length - 1 : s - 1
                    )
                  }
                />

                <IconButton
                  variant="outline"
                  borderRadius="full"
                  colorScheme="gray"
                  pos="absolute"
                  top="50%"
                  right={4}
                  transform="translateY(-50%)"
                  icon={<ChevronRightIcon />}
                  aria-label="Next"
                  onClick={() =>
                    setCurrentSlide((s) =>
                      s === props.slides.length - 1 ? 0 : s + 1
                    )
                  }
                />
              </>
            )}
          </Flex>
        </Center>
      </ModalContent>
    </Modal>
  );
};
